import React from 'react'
import Breadcrumb from '../../../components/breadcrumb/breadcrumb'
import Hero from '../../../components/hero-v2/hero'
import Layout from '../../../components/layouts/layout'
import Helmet from 'react-helmet'
import TiposDeAportesMenu from '../../../components/aportes-y-fondo/tipos-de-aportes/tipos-de-aportes-menu'

const Container = props => {
  const titlesBreadcrumb = {
    titlesIntermediate: [
      {
        index: 0,
        title: 'Empezando a aportar',
        link: '',
      },
    ],
    titleFinal: 'Tipos de aporte',
  }

  return (
    <Layout>
      <Helmet>
        <title>
          Información Detallada sobre los Tipos de Aportes | Prima AFP
        </title>
        <meta
          name="title"
          content="Información Detallada sobre los Tipos de Aportes | Prima AFP"
          data-react-helmet="true"
        />
        <meta
          name="description"
          content="Descubre los tipos de aportes a los que puedes acceder con Prima AFP: aportes para dependientes, independientes, aportes por Yape y aportes voluntarios."
          data-react-helmet="true"
        />
        <link
          rel="canonical"
          href="https://www.prima.com.pe/public-zone/aportes-y-fondo/tipos-de-aportes/"
        />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Inicio",  "item": "https://www.prima.com.pe/public-zone/"
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "Aportes y Fondo",  "item": "https://www.prima.com.pe/public-zone/aportes-y-fondo/"
                },
                {
                  "@type": "ListItem",
                  "position": 3,
                  "name": "Tipos de Aportes",  "item": "https://www.prima.com.pe/public-zone/aportes-y-fondo/tipos-de-aportes/"
                }
              ]
            }
          `}
        </script>
      </Helmet>

      <Hero
        preTitle="Soy afiliado"
        title="Tipos de "
        highlighted="aportes"
        imageBanner={'aportes-y-fondo/tipos-de-aportes/banner-tipos-de-aportes-desktop-transparent.png'}
        imageMobile={'aportes-y-fondo/tipos-de-aportes/banner-tipos-de-aportes-mobile.png'}
        arrowDown={true}
        className={'bg-yellow-1'}
      />

      <Breadcrumb
        GTMLink="/aportes-y-fondo/tipos-de-aportes/"
        GTMSection="Tipos de aporte"
        GTMTitle="Conoce los tipos de aportes que puedes realizar"
        GtmContainer="GTM-MOD-MEP-SECTION-TP-BREADCRUMB"
        GtmBeforeArrow="GTM-MOD-MEP-SECTION-TP-BREADCRUMB-BEFORE"
        GtmAfterArrow="GTM-MOD-MEP-SECTION-TP-BREADCRUMB-AFTER"
        titlesBreadcrumb={titlesBreadcrumb}
      />

      <section className="tw-pt-8 tw-pt-10@lg center">
        <div className={'containerWrap'}>
          <div className="c-gray--4 tw-mb-1 tw-mb-2@lg">
            <h2 className="font-family-secondary fw-7 tw-f-24 tw-f-24@lg">
              Conoce los tipos de aportes que puedes realizar
            </h2>
          </div>
        </div>
      </section>

      <section className="tw-pt-6 tw-pt-8@lg">
        <TiposDeAportesMenu props={props} />
        {props.children}
      </section>
    </Layout>
  )
};

export default Container;
